
import React, { useRef, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";



const Collection = () => {
  const scrollRef = useRef(null);
  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);
  const [brands, setBrands] = useState([]);
  const scrollLeft = () =>
    scrollRef.current.scrollBy({ left: -350, behavior: "smooth" });
  const scrollRight = () =>
    scrollRef.current.scrollBy({ left: 350, behavior: "smooth" });


  const navigate = useNavigate()




  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get("https://vantara.datacubeglobal.com/api/brands");
        if (response.data?.status === "success") {
          const { data, image_path } = response.data;
          const fullPath = "https://vantara.datacubeglobal.com/storage/BrandImage/";
          const formatted = data
            .filter((b) => b.status === 1)
            .map((b) => ({
              id: b.brand_id,
              name: b.brand_name,
              image: fullPath + b.image,
            }));

          setBrands(formatted);
          //  console.log(formatted, '✅ formatted brand data');

        }
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    fetchBrands();
  }, []);





  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            if (!visibleCards.includes(index)) {
              setVisibleCards((prev) => [...prev, index]);
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    cardRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [visibleCards, brands]);

  const handleNavigate = () => {
    navigate('/shop')
  }
  return (
    <div className="container-fluid px-0 my-5">
      {/* DESKTOP VIEW */}
      <div
        className="d-none d-md-block position-relative w-100"
        style={{ overflow: "hidden" }}
      >
        {/* Left Arrow */}
        <button
          className="btn btn-light rounded-circle shadow position-absolute start-0 top-50 translate-middle-y"
          style={{ zIndex: 10, width: "50px", height: "50px" }}
          onClick={scrollLeft}
        >
          ❮
        </button>

        {/* Scrollable Row */}
        <div
          ref={scrollRef}
          className="d-flex overflow-auto w-100"
          style={{
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            padding: "0 20px",
          }}
        >
          <style>{`.d-flex::-webkit-scrollbar { display: none; }`}</style>


          {brands.map((brand, index) => {
            const isVisible = visibleCards.includes(index);
            return (
              <div
                key={index}
                data-index={index}
                ref={(el) => (cardRefs.current[index] = el)}
                className="position-relative flex-shrink-0 overflow-hidden"
                style={{
                  width: "calc(32.33% - 10px)",
                  marginRight: index !== brands.length - 1 ? "14px" : "0",
                  marginLeft: index === 0 ? "20px" : "0",
                  height: "500px",
                  borderRadius: "15px",
                  cursor: "pointer",
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? "translateY(0)" : "translateY(50px)",
                  transition: `all 0.6s ease ${index * 0.2}s`,
                }}
              >
                {/* Background image div */}
                <div
                  className="w-100 h-100"
                  style={{
                    backgroundImage: `url(${brand.image})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    borderRadius: "15px",
                    transition: "transform 0.6s ease",
                  }}
                ></div>

                {/* Hover effect */}
                <style>
                  {`
          .position-relative.flex-shrink-0:hover .w-100.h-100 {
            transform: scale(1.1);
          }
            /* Hide carousel arrows on screens smaller than 768px (mobile) */
@media (max-width: 767px) {
  .carousel-control-prev,
  .carousel-control-next {
    display: none !important;
  }
}

        `}

                </style>

                {/* Text content */}
                <div
                  style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    color: "#000",
                  }}
                >
                  <h2
                    className=""
                    style={{ whiteSpace: "normal", maxWidth: "150px" }}
                  >
                    {brands.name}
                  </h2>

                  <p className="text-white fw-semibold">{brand.name}</p>
                </div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "20px",
                    color: "#fff",
                    fontWeight: "500",
                  }}
                >
                  <Link
  to="/shop"
  style={{
    color: "#fff",
    backgroundColor: "#7C0046",
    textDecoration: "none",
    padding: "10px 28px",     // gives the oval shape
    borderRadius: "50px",     // makes it rounded
    fontWeight: "600",
    letterSpacing: "0.5px",
    display: "inline-block",  // ensures padding applies correctly
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#1C3F1D"; // hover color
    e.target.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "#7C0046"; // revert color
    e.target.style.color = "#fff";
  }}
>
  Shop Collection &nbsp;  <span style={{ fontSize: "1.2rem" }}>→</span> 
</Link>

                </div>
              </div>
            );
          })}

        </div>

        {/* Right Arrow */}
        <button
          className="btn btn-light rounded-circle shadow position-absolute end-0 top-50 translate-middle-y"
          style={{ zIndex: 10, width: "50px", height: "50px" }}
          onClick={scrollRight}
        >
          ❯
        </button>
      </div>

      {/* MOBILE VIEW */}
      <div className="d-md-none px-3">
        <div
          id="collectionCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          {/* Indicators */}
          <div className="carousel-indicators">
            {brands.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#collectionCarousel"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : "false"}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>

          {/* Carousel Items */}
          <div className="carousel-inner">
            {brands.map((item, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                <div
                  style={{
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "500px",
                    borderRadius: "12px",
                    margin: "0 8px",
                    position: "relative",
                  }}
                >
                  {/* Text Content */}
                  <div
                    style={{
                      position: "absolute",
                      top: "20px",
                      left: "20px",
                      color: "#fff",
                      textShadow: "0 2px 6px rgba(0,0,0,0.6)",
                    }}
                  >
                    <h2 className="fw-bold">{brands.name}</h2>
                    <p className="text-danger fw-semibold">{brands.name}</p>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "20px",
                      color: "#fff",
                      fontWeight: "500",
                      textShadow: "0 2px 6px rgba(0,0,0,0.6)",
                    }}

                  >
                    <Link to={'/shop'} style={{
                      color: "#fff",      // white color
                      textDecoration: "none"
                    }}>      Shop Collection</Link>

                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#collectionCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#collectionCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Collection;







